import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { AlignPosition } from 'src/app/shared/enums';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.sass'],
})
export class PanelComponent {
  @Input() panelTitle: string;
  @Input() align: AlignPosition = AlignPosition.Top;
  @ViewChild('footer') footerElement: ElementRef;
  alignPosition = AlignPosition;
}
